const mmStorefrontRoot = document.querySelector("[data-magic-moments-storefront]");
const mmProductionAppBaseUrl = "https://app.momelio.com";
const mmPreviewEndpoint = mmStorefrontRoot?.dataset.previewEndpoint || `${mmProductionAppBaseUrl}/magic-moments/store/lyric-preview`;
const mmCheckoutEndpoint = mmStorefrontRoot?.dataset.checkoutEndpoint || `${mmProductionAppBaseUrl}/magic-moments/store/checkout-confirmation`;
const mmBannerFeedbackEndpoint = new URL("/magic-moments/store/banner-feedback", mmPreviewEndpoint || window.location.href).href;
const mmStyleSuggestionEndpoint = new URL("/magic-moments/store/style-suggestions", mmPreviewEndpoint || window.location.href).href;
const mmStyleSuggestionFeedbackEndpoint = new URL("/magic-moments/store/style-suggestion-feedback", mmPreviewEndpoint || window.location.href).href;
const mmSampleOneUrl = mmStorefrontRoot?.dataset.sampleOneUrl || "/static/magic_moments_samples/somehow-here.mp3";
const mmSampleTwoUrl = mmStorefrontRoot?.dataset.sampleTwoUrl || "/static/magic_moments_samples/lanai-lionheart.mp3";
const mmCustomerBannerPreviewEnabled = true;
const mmEndpointNeedsTunnelBypass = (endpoint) => {
  return false;
};
const mmJsonHeaders = (endpoint) => {
  const headers = {
    "Accept": "application/json",
    "Content-Type": "application/json"
  };
  if (mmEndpointNeedsTunnelBypass(endpoint)) headers["ngrok-skip-browser-warning"] = "true";
  return headers;
};


(() => {
      if (!mmStorefrontRoot) return;
      const menuButton = mmStorefrontRoot.querySelector(".store-menu-button");
      const mobileMenu = document.getElementById("storeMobileMenu");
      if (!menuButton || !mobileMenu) return;

      const setMenuOpen = (isOpen) => {
        mobileMenu.hidden = !isOpen;
        menuButton.setAttribute("aria-expanded", String(isOpen));
      };

      menuButton.addEventListener("click", (event) => {
        event.stopPropagation();
        setMenuOpen(mobileMenu.hidden);
      });

      mobileMenu.querySelectorAll("a").forEach((link) => {
        link.addEventListener("click", () => setMenuOpen(false));
      });

      document.addEventListener("click", (event) => {
        if (mobileMenu.hidden) return;
        if (mobileMenu.contains(event.target) || menuButton.contains(event.target)) return;
        setMenuOpen(false);
      });

      document.addEventListener("keydown", (event) => {
        if (event.key === "Escape") setMenuOpen(false);
      });
    })();

(() => {
      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent)
        || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
      if (!isIOS || !mmStorefrontRoot) return;
      const viewport = document.querySelector('meta[name="viewport"]');
      if (!viewport) return;

      const originalViewport = viewport.getAttribute("content") || "width=device-width, initial-scale=1";
      const editableSelector = 'input:not([type="range"]):not([type="hidden"]), textarea, select';
      const resetZoom = () => {
        window.setTimeout(() => {
          if (document.activeElement && document.activeElement.matches(editableSelector)) return;
          viewport.setAttribute("content", `${originalViewport}, maximum-scale=1`);
          window.requestAnimationFrame(() => viewport.setAttribute("content", originalViewport));
        }, 160);
      };

      mmStorefrontRoot.querySelectorAll(editableSelector).forEach((field) => {
        field.addEventListener("blur", resetZoom);
        field.addEventListener("focusout", resetZoom);
      });
    })();

(() => {
      const samples = [
        {
          title: "Forever Starts Here",
          style: "Country &bull; Anniversary",
          src: mmSampleOneUrl,
          next: "Listen to another sample &rarr;",
          label: "Play Forever Starts Here"
        },
        {
          title: "Lanai Lionheart",
          style: "EDM / Pop &bull; Pet",
          src: mmSampleTwoUrl,
          next: "Back to the anniversary sample &rarr;",
          label: "Play Lanai Lionheart"
        }
      ];
      const player = document.getElementById("samplePlayer");
      const button = document.getElementById("samplePlayButton");
      const title = document.getElementById("sampleTitle");
      const style = document.getElementById("sampleStyle");
      const toggle = document.getElementById("sampleToggle");
      const audio = document.getElementById("sampleAudio");
      const progress = document.getElementById("sampleProgress");
      const time = document.getElementById("sampleTime");
      if (!player || !button || !title || !style || !toggle || !audio || !progress || !time) return;

      let sampleIndex = 0;
      let touchStartX = 0;
      let isDraggingProgress = false;

      const formatTime = (seconds) => {
        if (!Number.isFinite(seconds) || seconds < 0) return "0:00";
        const minutes = Math.floor(seconds / 60);
        const remainder = Math.floor(seconds % 60);
        return `${minutes}:${String(remainder).padStart(2, "0")}`;
      };

      const syncProgress = () => {
        if (isDraggingProgress) return;
        const duration = Number(audio.duration || 0);
        const current = Number(audio.currentTime || 0);
        progress.value = duration > 0 ? String((current / duration) * 100) : "0";
        time.textContent = duration > 0 ? `${formatTime(current)} / ${formatTime(duration)}` : formatTime(current);
      };

      const seekToProgress = () => {
        const duration = Number(audio.duration || 0);
        if (duration > 0) {
          const percent = Number(progress.value || 0);
          const nextTime = (percent / 100) * duration;
          audio.currentTime = nextTime;
          time.textContent = `${formatTime(nextTime)} / ${formatTime(duration)}`;
        }
      };

      const keepProgressGestureLocal = (event) => {
        event.stopPropagation();
      };

      const renderSample = (index, shouldPlay = false) => {
        sampleIndex = index;
        const sample = samples[sampleIndex];
        audio.pause();
        audio.src = sample.src;
        audio.currentTime = 0;
        progress.value = "0";
        time.textContent = "0:00";
        title.textContent = sample.title;
        style.innerHTML = sample.style;
        toggle.innerHTML = sample.next;
        button.classList.remove("is-playing");
        button.setAttribute("aria-label", sample.label);
        if (shouldPlay) {
          audio.play().catch(() => {});
        }
      };

      const toggleSample = () => {
        renderSample(sampleIndex === 0 ? 1 : 0, false);
      };

      button.addEventListener("click", () => {
        if (audio.paused) {
          audio.play().catch(() => {});
        } else {
          audio.pause();
        }
      });

      toggle.addEventListener("click", toggleSample);

      progress.addEventListener("input", (event) => {
        keepProgressGestureLocal(event);
        const duration = Number(audio.duration || 0);
        if (duration > 0) {
          isDraggingProgress = true;
          const nextTime = (Number(progress.value || 0) / 100) * duration;
          audio.currentTime = nextTime;
          time.textContent = `${formatTime(nextTime)} / ${formatTime(duration)}`;
        }
      });

      progress.addEventListener("change", (event) => {
        keepProgressGestureLocal(event);
        seekToProgress();
        isDraggingProgress = false;
        syncProgress();
      });

      progress.addEventListener("pointerdown", (event) => {
        keepProgressGestureLocal(event);
        isDraggingProgress = true;
      });

      progress.addEventListener("pointerup", (event) => {
        keepProgressGestureLocal(event);
        seekToProgress();
        isDraggingProgress = false;
        syncProgress();
      });

      progress.addEventListener("touchstart", (event) => {
        keepProgressGestureLocal(event);
        isDraggingProgress = true;
      }, { passive: false });

      progress.addEventListener("touchmove", (event) => {
        keepProgressGestureLocal(event);
      }, { passive: false });

      progress.addEventListener("touchend", (event) => {
        keepProgressGestureLocal(event);
        seekToProgress();
        isDraggingProgress = false;
        syncProgress();
      }, { passive: false });

      progress.addEventListener("click", keepProgressGestureLocal);

      player.addEventListener("touchstart", (event) => {
        touchStartX = event.touches[0] ? event.touches[0].clientX : 0;
      }, { passive: true });

      player.addEventListener("touchend", (event) => {
        const endX = event.changedTouches[0] ? event.changedTouches[0].clientX : touchStartX;
        if (Math.abs(endX - touchStartX) > 44) {
          toggleSample();
        }
      }, { passive: true });

      audio.addEventListener("play", () => {
        button.classList.add("is-playing");
        button.setAttribute("aria-label", `Pause ${samples[sampleIndex].title}`);
      });

      audio.addEventListener("pause", () => {
        button.classList.remove("is-playing");
        button.setAttribute("aria-label", samples[sampleIndex].label);
      });

      audio.addEventListener("ended", () => {
        button.classList.remove("is-playing");
        syncProgress();
      });

      audio.addEventListener("loadedmetadata", syncProgress);
      audio.addEventListener("timeupdate", syncProgress);
      audio.addEventListener("durationchange", syncProgress);
    })();

    (() => {
      const form = document.getElementById("storeCheckoutForm");
      const status = document.getElementById("storeStatus");
      const resultPanel = document.getElementById("storeResult");
      const resultCopy = document.getElementById("storeResultCopy");
      const momentLink = document.getElementById("momentLink");
      const internalResultActions = document.getElementById("internalResultActions");
      const previewCard = document.getElementById("lyricPreviewCard");
      const previewTitle = document.getElementById("lyricPreviewTitle");
      const previewText = document.getElementById("lyricPreviewText");
      const bannerCard = document.getElementById("bannerPreviewCard");
      const bannerTitle = document.getElementById("bannerPreviewTitle");
      const bannerCopy = document.getElementById("bannerPreviewCopy");
      const bannerDescription = document.getElementById("bannerProductDescription");
      const bannerConceptList = document.getElementById("bannerConceptList");
      const bannerQuestion = document.getElementById("bannerFeedbackQuestion");
      const bannerActions = document.getElementById("bannerFeedbackActions");
      const storyField = form?.querySelector('[name="story_include"]');
      const soundRequestField = form?.querySelector('[name="sound_request"]');
      const pepperSuggestStyle = document.getElementById("pepperSuggestStyle");
      const pepperStyleCard = document.getElementById("pepperStyleCard");
      const pepperStyleLabel = document.getElementById("pepperStyleLabel");
      const pepperStyleWhy = document.getElementById("pepperStyleWhy");
      const pepperUseStyle = document.getElementById("pepperUseStyle");
      const pepperTryAnother = document.getElementById("pepperTryAnother");
      if (!form || !status || !resultPanel || !resultCopy || !momentLink || !previewCard || !previewTitle || !previewText) return;
      const isShopifyBetaHost = /(^|\.)myshopify\.com$/i.test(window.location.hostname) || /(momelio|magic-moments)/i.test(window.location.hostname);

      const value = (formData, key, fallback = "") => String(formData.get(key) || fallback).trim();
      let previewReady = false;
      let previewPayload = null;
      let previewToken = "";
      let pepperStyleOptions = [];
      let pepperStyleIndex = 0;

      const delay = (ms) => new Promise((resolve) => window.setTimeout(resolve, ms));
      const resolveBackendUrl = (path) => {
        if (!path) return "";
        try {
          return new URL(path, mmPreviewEndpoint || window.location.href).href;
        } catch (_error) {
          return path;
        }
      };

      const fallbackPepperStyles = (story) => {
        const text = String(story || "").toLowerCase();
        const hasAny = (terms) => terms.some((term) => text.includes(term));
        const petTerms = ["dog", "cat", "pet", "puppy", "kitten", "retriever", "golden", "fetch", "paw"];
        const beachTerms = ["beach", "ocean", "shore", "coast", "walk", "walking", "sand", "waves", "seaside"];
        const beerTerms = ["beer", "brew", "bar", "cheers", "tailgate"];
        const danceTerms = ["edm", "house", "dance", "club", "rave", "vegas", "las vegas", "pool", "dj", "hype", "party anthem"];
        const islandTerms = ["jamaica", "reggae", "island", "tropical", "caribbean", "beach trip", "slow relaxing", "sunny days"];
        const childTerms = ["kid", "child", "daughter", "son", "niece", "nephew", "little", "turning 1", "turning 2", "turning 3", "turning 4", "turning 5", "turning 6", "turning 7", "turning 8", "six", "seven", "princess", "superhero", "toy", "disney", "fairy", "fairytale", "castle", "magic", "dance class", "ballet"];
        const babyTerms = ["baby", "pregnant", "pregnancy", "born", "newborn", "expecting", "belly"];
        const memorialTerms = ["memorial", "passed", "loss", "grief", "remember", "miss"];
        const birthdayTerms = ["birthday", "turning", "years old", "party"];
        const loveTerms = ["anniversary", "wife", "husband", "fiance", "love", "married", "wedding"];
        const familyTerms = ["mom", "dad", "mother", "father", "grandma", "grandpa", "nana", "papa", "family", "daughter", "son", "uncle", "aunt", "thank you", "raised me", "always there"];
        const countryTerms = ["country", "farm", "truck", "fishing", "hunting", "boots", "bonfire", "dirt road", "porch", "lake", "tennessee", "texas", "southern", "rodeo"];
        const inspirationalTerms = ["overcame", "proud", "fighter", "survivor", "journey", "dream", "worked hard", "comeback", "strong", "never gave up", "new chapter"];
        const hasPet = hasAny(petTerms);
        const hasChild = hasAny(childTerms);

        if (hasAny(islandTerms)) {
          return [
            { label: "Sunny reggae-pop", why: "Relaxed, warm, and naturally tied to the Jamaica beach feeling." },
            { label: "Island acoustic groove", why: "Slow, sunny, and easygoing without getting sleepy." },
            { label: "Tropical soul-pop", why: "Smooth and warm with a little vacation glow." }
          ];
        }
        if (hasPet && !hasChild && hasAny(beachTerms)) {
          return [
            { label: "Sunny acoustic country", why: "Warm, easygoing, and personal for a beach-walk pet story." },
            { label: "Beachy country-pop", why: "Playful and heartfelt without needing music terms." },
            { label: "Feel-good acoustic groove", why: "Light, friendly, and relaxed for an everyday happy memory." }
          ];
        }
        if (hasPet && !hasChild) {
          return [
            { label: "Playful acoustic country", why: "Warm and affectionate for a pet story." },
            { label: "Upbeat folk-pop", why: "Friendly, simple, and full of personality." },
            { label: "Feel-good pop-rock", why: "Energetic without getting too slick." }
          ];
        }
        if (hasChild) {
          return [
            { label: "Storybook musical pop", why: "Bright, magical, and kid-friendly without using a branded sound." },
            { label: "Playful sing-along", why: "Simple, happy, and easy for a child to enjoy." },
            { label: "Animated adventure pop", why: "Big, colorful, and imaginative while staying family-friendly." }
          ];
        }
        if (hasAny(danceTerms)) {
          return [
            { label: "EDM-pop celebration", why: "High-energy, bright, and built around the party setting." },
            { label: "Tropical house anthem", why: "Sunny, polished, and made for poolside energy." },
            { label: "Dance-pop anthem", why: "Catchy and upbeat without needing music terms." }
          ];
        }
        if (hasAny(beerTerms) || hasAny(["football", "nascar", "fishing", "camping", "country"])) {
          return [
            { label: "Southern country-rock", why: "Big-hearted, fun, and built for a singalong moment." },
            { label: "Blue-collar country", why: "Grounded and personal with a little grit." },
            { label: "Acoustic country anthem", why: "Warm and familiar without feeling overproduced." }
          ];
        }
        if (hasAny(babyTerms) || hasAny(loveTerms)) {
          return [
            { label: "Tender acoustic pop", why: "Soft, emotional, and easy to connect with." },
            { label: "Warm country ballad", why: "Heartfelt and story-forward." },
            { label: "Cinematic piano pop", why: "Polished, emotional, and intimate." }
          ];
        }
        if (hasAny(memorialTerms)) {
          return [
            { label: "Gentle piano ballad", why: "Respectful, reflective, and emotionally clear." },
            { label: "Soft acoustic tribute", why: "Personal and sincere without becoming too heavy." },
            { label: "Cinematic memorial song", why: "Slow, warm, and built around remembrance." }
          ];
        }
        if (hasAny(familyTerms)) {
          return [
            { label: "Heartfelt acoustic pop", why: "Warm and personal, with the focus on gratitude and memories." },
            { label: "Classic soft rock tribute", why: "Timeless and familiar, especially for parents or grandparents." },
            { label: "Cinematic piano ballad", why: "Emotional and polished for a deeper thank-you message." }
          ];
        }
        if (hasAny(countryTerms)) {
          return [
            { label: "Modern country ballad", why: "Warm, story-driven, and familiar without feeling old-fashioned." },
            { label: "Country-pop singalong", why: "Catchy and heartfelt with a little more energy." },
            { label: "Southern rock anthem", why: "Bigger and more rugged for stories with grit, humor, or celebration." }
          ];
        }
        if (hasAny(inspirationalTerms)) {
          return [
            { label: "Inspirational pop anthem", why: "Uplifting and emotional, built to make the moment feel big." },
            { label: "Cinematic pop ballad", why: "Powerful and polished, with a more dramatic emotional lift." },
            { label: "Soulful gospel-pop", why: "Warm, hopeful, and powerful when the story carries faith, resilience, or gratitude." }
          ];
        }
        if (hasAny(birthdayTerms)) {
          return [
            { label: "Upbeat pop celebration", why: "Bright, catchy, and easy for everyone to enjoy." },
            { label: "Feel-good country-pop", why: "Warm, personal, and celebratory with a little singalong charm." },
            { label: "Inspirational pop anthem", why: "Best when the story is about growth, pride, and a big life moment." }
          ];
        }
        return [
          { label: "Warm acoustic pop", why: "A flexible, emotional default for personal stories." },
          { label: "Story-driven country", why: "Great when the details and relationships matter most." },
          { label: "Feel-good pop-rock", why: "Playful, affectionate, and energetic without needing music terms." }
        ];
      };

      const expandPepperStyles = (suggestions) => {
        const expanded = Array.isArray(suggestions) ? suggestions.filter(Boolean) : [];
        const palette = [
          { label: "Acoustic storyteller", why: "Personal, clear, and built around the story." },
          { label: "Soulful piano pop", why: "Warm, emotional, and polished without feeling complicated." },
          { label: "Story-driven country", why: "Great when the details and relationships matter most." },
          { label: "Feel-good pop-rock", why: "Playful, affectionate, and energetic without getting too slick." },
          { label: "Smooth R&B groove", why: "Warm, relaxed, and a little more modern." },
          { label: "Cinematic piano pop", why: "Emotional and polished when the story needs a bigger feeling." },
          { label: "Upbeat funk-pop", why: "Light, playful, and good for a story with personality." }
        ];
        const seen = new Set(expanded.map((item) => String(item.label || "").toLowerCase()).filter(Boolean));
        palette.forEach((item) => {
          const label = String(item.label || "").toLowerCase();
          if (expanded.length >= 7 || !label || seen.has(label)) return;
          expanded.push(item);
          seen.add(label);
        });
        return expanded.slice(0, 7);
      };

      const recordPepperStyleSignal = (action) => {
        const suggestion = pepperStyleOptions[pepperStyleIndex] || {};
        const formData = new FormData(form);
        fetch(mmStyleSuggestionFeedbackEndpoint, {
          method: "POST",
          headers: mmJsonHeaders(mmStyleSuggestionFeedbackEndpoint),
          cache: "no-store",
          body: JSON.stringify({
            action,
            customer_name: value(formData, "customer_name"),
            customer_email: value(formData, "customer_email"),
            story_include: storyField ? storyField.value.trim() : "",
            sound_request: soundRequestField ? soundRequestField.value.trim() : "",
            selected_label: suggestion.label || "",
            selected_index: String(pepperStyleIndex),
            suggestion_labels: pepperStyleOptions.map((item) => item && item.label).filter(Boolean),
            source_platform: value(formData, "source_platform", "shopify_beta")
          })
        }).catch(() => {});
      };

      const renderPepperStyle = () => {
        if (!pepperStyleCard || !pepperStyleLabel || !pepperStyleWhy || !pepperStyleOptions.length) return;
        const suggestion = pepperStyleOptions[pepperStyleIndex] || pepperStyleOptions[0];
        pepperStyleLabel.textContent = suggestion.label || "Warm acoustic pop";
        pepperStyleWhy.textContent = suggestion.why || "A flexible, emotional style for your story.";
        pepperStyleCard.hidden = false;
      };

      const requestPepperStyles = async () => {
        const story = storyField ? storyField.value.trim() : "";
        const soundRequest = soundRequestField ? soundRequestField.value.trim() : "";
        if (!story) {
          status.textContent = "Add a little story first, then Pepper can suggest a style.";
          status.classList.add("error");
          return;
        }
        status.classList.remove("error");
        if (pepperSuggestStyle) {
          pepperSuggestStyle.disabled = true;
          pepperSuggestStyle.textContent = "Pepper is thinking...";
        }
        try {
          const response = await fetch(mmStyleSuggestionEndpoint, {
            method: "POST",
            headers: mmJsonHeaders(mmStyleSuggestionEndpoint),
            cache: "no-store",
            body: JSON.stringify({ story_include: story, sound_request: soundRequest })
          });
          const data = await response.json();
          if (!response.ok || data.ok === false || !Array.isArray(data.suggestions) || !data.suggestions.length) {
            throw new Error(data.message || "Pepper could not suggest a style yet.");
          }
          pepperStyleOptions = expandPepperStyles(data.suggestions);
          pepperStyleIndex = 0;
          renderPepperStyle();
          status.textContent = "";
        } catch (_error) {
          pepperStyleOptions = expandPepperStyles(fallbackPepperStyles(story));
          pepperStyleIndex = 0;
          renderPepperStyle();
          status.textContent = "";
        } finally {
          if (pepperSuggestStyle) {
            pepperSuggestStyle.disabled = false;
            pepperSuggestStyle.textContent = "Suggest a Style";
          }
        }
      };

      const bringPreviewIntoView = (mode = "preview") => {
        window.requestAnimationFrame(() => {
          const anchor = mode === "ready" ? (button || previewCard) : previewCard;
          const rect = anchor.getBoundingClientRect();
          const offset = mode === "ready" ? Math.min(96, Math.max(48, window.innerHeight * 0.10)) : 14;
          const targetTop = Math.max(0, rect.top + window.scrollY - offset);
          window.scrollTo({ top: targetTop, behavior: "smooth" });
        });
      };

      let bannerFullscreenOverlay = null;
      let bannerFullscreenImage = null;
      let bannerFullscreenClose = null;
      const closeBannerFullscreen = () => {
        if (!bannerFullscreenOverlay) return;
        bannerFullscreenOverlay.classList.remove("open");
        bannerFullscreenOverlay.setAttribute("aria-hidden", "true");
        document.body.classList.remove("banner-fullscreen-open");
        if (bannerFullscreenImage) {
          bannerFullscreenImage.removeAttribute("src");
          bannerFullscreenImage.alt = "";
        }
      };
      const ensureBannerFullscreenOverlay = () => {
        if (bannerFullscreenOverlay) return bannerFullscreenOverlay;
        bannerFullscreenOverlay = document.createElement("div");
        bannerFullscreenOverlay.className = "banner-fullscreen-preview";
        bannerFullscreenOverlay.setAttribute("role", "dialog");
        bannerFullscreenOverlay.setAttribute("aria-modal", "true");
        bannerFullscreenOverlay.setAttribute("aria-hidden", "true");

        bannerFullscreenImage = document.createElement("img");
        bannerFullscreenImage.alt = "";
        bannerFullscreenOverlay.appendChild(bannerFullscreenImage);

        bannerFullscreenClose = document.createElement("button");
        bannerFullscreenClose.type = "button";
        bannerFullscreenClose.className = "banner-fullscreen-close";
        bannerFullscreenClose.textContent = "Close";
        bannerFullscreenClose.addEventListener("click", closeBannerFullscreen);
        bannerFullscreenOverlay.appendChild(bannerFullscreenClose);

        bannerFullscreenOverlay.addEventListener("click", (event) => {
          if (event.target === bannerFullscreenOverlay) closeBannerFullscreen();
        });
        document.body.appendChild(bannerFullscreenOverlay);
        return bannerFullscreenOverlay;
      };
      const openBannerFullscreen = (imageUrl, altText) => {
        if (!imageUrl) return;
        ensureBannerFullscreenOverlay();
        bannerFullscreenImage.src = imageUrl;
        bannerFullscreenImage.alt = altText || "Birthday banner preview";
        bannerFullscreenOverlay.classList.add("open");
        bannerFullscreenOverlay.setAttribute("aria-hidden", "false");
        document.body.classList.add("banner-fullscreen-open");
        if (bannerFullscreenClose) bannerFullscreenClose.focus({ preventScroll: true });
      };
      document.addEventListener("keydown", (event) => {
        if (event.key === "Escape") closeBannerFullscreen();
      });

      const buildPayload = () => {
        const formData = new FormData(form);
        return {
          customer_name: value(formData, "customer_name"),
          customer_email: value(formData, "customer_email"),
          story_include: value(formData, "story_include"),
          sound_request: value(formData, "sound_request"),
          style_request: value(formData, "sound_request"),
          song_length: value(formData, "song_length", "normal"),
          avoid: value(formData, "avoid"),
          base_product: value(formData, "base_product", "custom_song"),
          order_value: Number(value(formData, "order_value", "10")) || 10,
          payment_status: value(formData, "payment_status", "payment_confirmed"),
          source: value(formData, "source", "local_mock_storefront"),
          source_platform: value(formData, "source_platform", "local_storefront"),
          business_id: "magic_moments",
          business_name: "Momelio"
        };
      };

      const typeLine = async (line) => {
        previewText.textContent = "";
        for (const char of line) {
          previewText.textContent += char;
          await delay(34);
        }
      };

      const runPreviewStatus = async (shouldContinue) => {
        const lines = [
          "This can take up to about a minute",
          "Winston is using your story to craft your Moment",
          "Finding the details that matter",
          "Shaping your first verse",
          "Checking the rhythm against your story",
          "Holding the good parts up to the light"
        ];
        while (shouldContinue()) {
          for (const line of lines) {
            if (!shouldContinue()) return;
            await typeLine(line + "...");
            if (!shouldContinue()) return;
            await delay(700);
            if (!shouldContinue()) return;
          }
        }
      };

      const validatePayload = (payload) => {
        if (!payload.customer_name || !payload.customer_email || !payload.story_include) {
          status.textContent = "Name, email, and story are required.";
          status.classList.add("error");
          return false;
        }
        return true;
      };

      const requestPreview = async (payload) => {
        const response = await fetch(mmPreviewEndpoint, {
          method: "POST",
          headers: mmJsonHeaders(mmPreviewEndpoint),
          cache: "no-store",
          body: JSON.stringify(payload)
        });
        const data = await response.json();
        if (!response.ok || data.ok === false || !data.preview_verse) {
          throw new Error(data.message || "Winston could not prepare the lyric preview yet.");
        }
        return data;
      };

      const clearBannerPreview = () => {
        if (!bannerCard) return;
        bannerCard.classList.remove("open");
        if (bannerConceptList) bannerConceptList.replaceChildren();
        if (bannerActions) bannerActions.replaceChildren();
        if (bannerCopy) bannerCopy.textContent = "";
        if (bannerDescription) bannerDescription.textContent = "";
        if (bannerQuestion) bannerQuestion.textContent = "";
      };

      const renderBannerPreview = (concept) => {
        if (!mmCustomerBannerPreviewEnabled) {
          clearBannerPreview();
          return;
        }
        if (!bannerCard || !concept || concept.banner_eligible !== true) {
          clearBannerPreview();
          return;
        }
        const template = concept.product_template || {};
        const candidates = Array.isArray(concept.mockup_candidates)
          ? concept.mockup_candidates.filter((candidate) => {
              return candidate && (candidate.preview_image_data_url || candidate.preview_image_url || candidate.preview_image_path);
            })
          : [];
        if (!candidates.length) {
          clearBannerPreview();
          return;
        }
        const productView = {
          candidate_id: "printify_matte_banner_product_preview",
          label: "Real Matte Banner",
          headline: "48 x 24 Matte Banner",
          style_variant: "unprinted_product_preview",
          product_view: true
        };
        const bannerViews = [...candidates, productView];
        if (bannerTitle) bannerTitle.textContent = template.display_name || "Birthday Banner Concept";
        if (bannerCopy) {
          bannerCopy.textContent = "";
          bannerCopy.hidden = true;
        }
        if (bannerDescription) {
          bannerDescription.textContent = "";
          bannerDescription.hidden = true;
        }
        if (bannerConceptList) {
          bannerConceptList.replaceChildren();
          let activeBannerIndex = 0;
          const renderCandidate = () => {
            bannerConceptList.replaceChildren();
            const candidate = bannerViews[activeBannerIndex] || bannerViews[0];
            if (!candidate) return;
            bannerCard.dataset.activeBannerId = candidate.candidate_id || "";
            bannerCard.dataset.activeBannerLabel = candidate.label || "";
            bannerCard.dataset.activeBannerVariant = candidate.style_variant || "";
            const item = document.createElement("div");
            item.className = "banner-concept";
            if (candidate.product_view) {
              const mockup = document.createElement("div");
              mockup.className = "banner-product-mockup";
              mockup.setAttribute("aria-label", "Unprinted 48 by 24 inch matte banner preview");
              mockup.innerHTML = '<span class="mockup-grommet mockup-grommet-left"></span><span class="mockup-grommet mockup-grommet-right"></span><strong>Unprinted matte banner</strong><em>48 x 24 in / 4 ft x 2 ft</em>';
              item.appendChild(mockup);
            } else {
              const imageUrl = candidate.preview_image_data_url || resolveBackendUrl(candidate.preview_image_url || candidate.preview_image_path || "");
              const imageButton = document.createElement("button");
              imageButton.type = "button";
              imageButton.className = "banner-concept-image-button";
              imageButton.setAttribute("aria-label", "Open full-screen banner preview");
              const image = document.createElement("img");
              image.className = "banner-concept-image";
              image.src = imageUrl;
              image.alt = candidate.preview_image_alt || `${candidate.headline || candidate.label || "Birthday banner"} preview`;
              image.loading = "lazy";
              imageButton.addEventListener("click", () => openBannerFullscreen(imageUrl, image.alt));
              imageButton.appendChild(image);
              item.appendChild(imageButton);
            }
            const headline = document.createElement("strong");
            headline.textContent = candidate.headline || candidate.label || "Banner concept";
            item.appendChild(headline);
            if (candidate.product_view) {
              const note = document.createElement("span");
              note.textContent = `${template.customer_facing_price || "$49.99 with free shipping"} beta price. Experimental preview only; nothing physical is printed or shipped in this test.`;
              item.appendChild(note);
            }
            bannerConceptList.appendChild(item);
            if (bannerViews.length > 1) {
              const toggle = document.createElement("button");
              toggle.type = "button";
              toggle.className = "banner-version-toggle";
              toggle.textContent = activeBannerIndex === 0
                ? "See digital style \u2192"
                : activeBannerIndex === 1
                  ? "See real banner \u2192"
                  : "\u2190 Back to hand-painted style";
              toggle.addEventListener("click", () => {
                activeBannerIndex = (activeBannerIndex + 1) % bannerViews.length;
                renderCandidate();
              });
              bannerConceptList.appendChild(toggle);
            }
          };
          renderCandidate();
        }
        if (bannerQuestion) {
          bannerQuestion.textContent = concept.beta_feedback_question || "Experimental preview only: no banner will be printed or shipped. Would a personalized 48 x 24 birthday banner like this feel worth $49.99 for the occasion?";
        }
        if (bannerActions) {
          bannerActions.replaceChildren();
          (concept.beta_feedback_options || ["Love it", "Maybe", "Not for me"]).forEach((option) => {
            const choice = document.createElement("button");
            choice.type = "button";
            choice.textContent = option;
            choice.addEventListener("click", () => {
              bannerActions.querySelectorAll("button").forEach((other) => other.classList.remove("selected"));
              choice.classList.add("selected");
              status.textContent = `Banner feedback noted: ${option}.`;
              const feedbackPayload = buildPayload();
              feedbackPayload.preview_token = previewToken;
              feedbackPayload.feedback = option;
              feedbackPayload.question = concept.beta_feedback_question || "";
              feedbackPayload.banner_option_id = bannerCard.dataset.activeBannerId || "";
              feedbackPayload.banner_option_label = bannerCard.dataset.activeBannerLabel || "";
              feedbackPayload.banner_option_variant = bannerCard.dataset.activeBannerVariant || "";
              fetch(mmBannerFeedbackEndpoint, {
                method: "POST",
                headers: mmJsonHeaders(mmBannerFeedbackEndpoint),
                cache: "no-store",
                body: JSON.stringify(feedbackPayload)
              }).catch(() => {});
            });
            bannerActions.appendChild(choice);
          });
        }
        bannerCard.classList.add("open");
      };

      form.addEventListener("input", () => {
        pepperStyleOptions = [];
        pepperStyleIndex = 0;
        if (pepperStyleCard) pepperStyleCard.hidden = true;
        if (!previewReady) return;
        previewReady = false;
        previewPayload = null;
        previewToken = "";
        clearBannerPreview();
        previewCard.classList.remove("ready");
    previewTitle.textContent = "Preparing your Verse 1 preview";
        previewText.textContent = "";
        const button = form.querySelector("button[type='submit']");
    if (button) {
          button.textContent = "Preview Verse 1 Free";
          button.classList.remove("is-unlock-ready");
        }
        status.textContent = "";
      });

      if (pepperSuggestStyle) {
        pepperSuggestStyle.addEventListener("click", requestPepperStyles);
      }

      if (pepperTryAnother) {
        pepperTryAnother.addEventListener("click", () => {
          if (!pepperStyleOptions.length) {
            pepperStyleOptions = expandPepperStyles(fallbackPepperStyles(storyField ? storyField.value : ""));
          }
          pepperStyleIndex = (pepperStyleIndex + 1) % pepperStyleOptions.length;
          renderPepperStyle();
          recordPepperStyleSignal("try_another");
        });
      }

      if (pepperUseStyle) {
        pepperUseStyle.addEventListener("click", () => {
          const suggestion = pepperStyleOptions[pepperStyleIndex] || {};
          if (!soundRequestField || !suggestion.label) return;
          recordPepperStyleSignal("use_style");
          soundRequestField.value = suggestion.label;
          soundRequestField.dispatchEvent(new Event("input", { bubbles: true }));
          status.classList.remove("error");
          status.textContent = "Pepper added that style for you.";
        });
      }

      form.addEventListener("submit", async (event) => {
        event.preventDefault();
        const button = form.querySelector("button[type='submit']");
        const payload = buildPayload();

        if (!validatePayload(payload)) {
          return;
        }

        if (button) button.disabled = true;
        status.classList.remove("error");
        resultPanel.classList.remove("open");

        if (!previewReady) {
          previewPayload = payload;
          form.classList.add("is-previewing");
          previewCard.classList.add("open");
          previewCard.classList.remove("ready");
          if (button) button.classList.remove("is-unlock-ready");
          previewTitle.textContent = "Preparing your preview";
          previewText.textContent = "This can take up to about a minute.";
          status.textContent = "Winston is preparing your preview. This could take up to a minute. No action needed.";
          if (button) button.textContent = "No Action Needed";
          bringPreviewIntoView();

          let keepStatusMoving = true;
          const statusTask = runPreviewStatus(() => keepStatusMoving);
          try {
            const data = await requestPreview(payload);
            keepStatusMoving = false;
            await statusTask;
            previewTitle.textContent = "Your Verse 1 preview";
            previewText.textContent = data.preview_verse;
            previewCard.classList.add("ready");
            renderBannerPreview(data.banner_concept);
            previewReady = true;
            previewToken = data.preview_token || "";
            status.textContent = "Preview ready.";
            if (button) {
              button.textContent = "Unlock Full Song";
              button.classList.add("is-unlock-ready");
            }
            bringPreviewIntoView("ready");
          } catch (error) {
            keepStatusMoving = false;
            await statusTask;
            previewTitle.textContent = "Preview unavailable";
            previewText.textContent = error.message || "Winston could not prepare the lyric preview yet.";
            status.textContent = error.message || "The lyric preview failed.";
            status.classList.add("error");
            if (button) {
              button.textContent = "Preview My Lyrics";
              button.classList.remove("is-unlock-ready");
            }
          } finally {
            form.classList.remove("is-previewing");
            if (button) button.disabled = false;
          }
          return;
        }

        if (previewPayload) {
          Object.assign(payload, previewPayload, {
            customer_name: payload.customer_name,
            customer_email: payload.customer_email,
            story_include: payload.story_include,
            sound_request: payload.sound_request,
            style_request: payload.sound_request,
            avoid: payload.avoid
          });
        }
        payload.preview_token = previewToken;
        if (button) button.classList.remove("is-unlock-ready");

        status.textContent = "Opening secure test checkout...";

        try {
          const response = await fetch(mmCheckoutEndpoint, {
            method: "POST",
            headers: mmJsonHeaders(mmCheckoutEndpoint),
            cache: "no-store",
            body: JSON.stringify(payload)
          });
          const data = await response.json();
          if (!response.ok || data.ok === false || !data.order_id) {
            throw new Error(data.message || "The test checkout could not create an order.");
          }

          const checkoutEndpointUrl = new URL(mmCheckoutEndpoint || window.location.href, window.location.href);
          const myMomentSource = data.my_moment_url || `/my-moment/${encodeURIComponent(data.order_id)}`;
          const myMomentPath = new URL(myMomentSource, checkoutEndpointUrl).pathname;
          const myMomentUrl = `${checkoutEndpointUrl.origin}${myMomentPath}`;
          if (isShopifyBetaHost) {
            status.textContent = "Opening your My Moment...";
            window.location.assign(myMomentUrl);
            return;
          }
          momentLink.href = myMomentUrl;
          if (internalResultActions) {
            internalResultActions.hidden = isShopifyBetaHost;
          }
          resultCopy.textContent = data.warning || (
            isShopifyBetaHost
        ? "Your Verse 1 preview is saved and your song request was received. We'll send your private My Moment link when your song is ready."
              : "Your Moment is started. You can open your private My Moment page below when you're ready."
          );
          resultPanel.classList.toggle("open", !isShopifyBetaHost);
          status.textContent = isShopifyBetaHost
            ? "Your song request was received. We'll send your private My Moment link when it's ready."
            : "Your Moment is started.";
          form.reset();
        } catch (error) {
          status.textContent = error.message || "The test checkout failed.";
          status.classList.add("error");
        } finally {
          if (button) button.disabled = false;
        }
      });
    })();
